import * as React from 'react'
import { SEARCH_PAGE_AI_CONTENT_ENABLED_TOGGLE_COOKIE_NAME } from 'constants/cookies'
import { getCookie, setCookie } from 'utils/dom'
import { useFeatureIsOn } from 'growthbook'
import { useUserIsDesigner } from '@repo/cf-user/hooks/use-user-data'

export function useAreAIProductsEnabledOnSearch() {
  const isDesigner = useUserIsDesigner()
  const [isAiContentEnabled, setIsAiContentEnabled] = React.useState<boolean>(() => {
    const cookieValue = getCookie(SEARCH_PAGE_AI_CONTENT_ENABLED_TOGGLE_COOKIE_NAME)

    // Cookie is not set, so we use the designer status to determine the default value
    if (cookieValue === '') {
      return !!isDesigner
    }

    // Otherwise, we use the cookie value to determine the default value
    return cookieValue === 'true'
  })

  const isFeatureOn = useFeatureIsOn('GROW-1281-enable-ai-products-on-search')

  const handleSetIsAiContentEnabled = (enabled: boolean) => {
    if (!isFeatureOn) {
      return
    }

    setIsAiContentEnabled(enabled)
    setCookie({
      name: SEARCH_PAGE_AI_CONTENT_ENABLED_TOGGLE_COOKIE_NAME,
      value: enabled.toString(),
      path: '/',
      expiresIn: 1000 * 60 * 60 * 24 * 365 * 10, // 10 years
      domain: '.creativefabrica.com',
    })
  }

  return {
    isAiContentEnabled: isFeatureOn ? isAiContentEnabled : false,
    setIsAiContentEnabled: handleSetIsAiContentEnabled,
  }
}
